var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandRoundDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4379_39724)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDF0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.55C11.8667 16.55 11.7417 16.5292 11.625 16.4875C11.5084 16.4458 11.4 16.375 11.3 16.275L6.70005 11.675C6.51672 11.4917 6.42505 11.2583 6.42505 10.975C6.42505 10.6917 6.51672 10.4583 6.70005 10.275C6.88338 10.0917 7.11672 10 7.40005 10C7.68338 10 7.91672 10.0917 8.10005 10.275L12 14.175L15.9 10.275C16.0834 10.0917 16.3167 10 16.6 10C16.8834 10 17.1167 10.0917 17.3 10.275C17.4834 10.4583 17.575 10.6917 17.575 10.975C17.575 11.2583 17.4834 11.4917 17.3 11.675L12.7 16.275C12.6 16.375 12.4917 16.4458 12.375 16.4875C12.2584 16.5292 12.1334 16.55 12 16.55Z",
    fill: "#1C2227"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4379_39724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandRoundDown);
export default __webpack_public_path__ + "static/media/expand_roundDown.731acf22ab2ad8a3a99c05250094c396.svg";
export { ForwardRef as ReactComponent };